<template>
  <div class="container flex" style="padding-bottom: 20px;margin-top: 15px;">
    <left></left>
    <div class="right" style="margin-left: 20px;flex:1;">
      <threecategory  @initData="initData"></threecategory>
      <div class="live topprograss" style="background-color: #fff;">
      	<div class="flex">
      		<div class="left flex1">
      			<div class="top">
      				<span style="margin-right: 15px;width: 70PX;">做题进度</span>
      				<div class="prograss">
      					<span class="rato"  :style="'width: '+data.alreadyQuestionCount/data.totalQuestionCount*100+'%'"></span>
      				</div>
      				<span class="done">已做：{{data.alreadyQuestionCount}}</span>/ 总数：{{data.totalQuestionCount}}
      			</div>
      			<div class="bottom" style="margin-top: 30px;">
      				<span style="margin-right: 15px;width: 70PX;">正确率</span>
      				<div class="prograss">
      					<span class="rato"  :style="'width: '+data.answerRatio+'%'"></span>
      				</div>
      				正确率：
      				<span class="done">{{data.answerRatio}}</span>
      			</div>
      		</div>
      	<!-- 	<div class="btn">
      			开始练习
      		</div> -->
      	</div>
      </div>
      <div class="live" style="background-color: #fff;margin-top: 20px;">
        <div class="title">
          {{ title }}
        </div>
        <template v-for="item, index in list">
          <div class="lists">
            <div class="listtile" @click="handleToggle(index)">
              {{ item.title }}
            </div>
            <div class="line" v-show="item.show"></div>
            <div class="list" v-for="voo in item.testQuestionsChildList" v-show="item.show">
              <span class="childName">{{ voo.title }}</span>

              <div class="viewWrap">
                <span class="view" @click="handleTest(voo.totalQuestionsCount, voo.testQuestionsId, voo.cacheCount)"
                  v-if="isbuy">答题</span>
                <span class="view" @click="handleTest(voo.totalQuestionsCount, voo.testQuestionsId, voo.cacheCount)"
                  v-if="!isbuy && (voo.payStatus == 0)">试做</span>
                <span class="view" @click="handleToBuy()" v-if="!isbuy && (voo.payStatus == 1)">购买</span>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import left from './left.vue'
import threecategory from './threecategory.vue'
import bus from '../assets/utils/eventBus.js';
export default {
  name: 'Footer',
  components: {
    left,
    threecategory
  },
  data () {
    return {
      data: '',
      pageNo: 1,
      pageSize: 100,
      questionsStatus: 5,
      list: [],
      title: '阶段测试',
      isbuy: this.$store.state.isbuy
    }
  },
  methods: {
    handleToBuy () {
      this.$router.push('buy')
    },
    getData () {
      let data = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        questionsStatus: this.questionsStatus,
      };
      this.$axios.get(this.$common.testPaper_exercisesList, { params: data }).then((res) => {
        if (res.data.code == 1) {
          this.list = res.data.data.list;
        }
        else {
          alert(res.data.msg)
        }
      })
    },
    handleTest (totalQuestionsCount, testQuestionsId, cacheCount) {
      if (totalQuestionsCount == 0) {
        alert('上题中');
        return;
      }
      this.$router.push({ path: 'homework?questionsStatus=' + this.questionsStatus + '&testQuestionsId=' + testQuestionsId + '&cacheCount=' + cacheCount })
    },
    handleToggle (index) {
      this.$forceUpdate()
      this.list[index].show = !this.list[index].show;

    },
    getDatas(){
      this.$axios.get(this.$common.testPaper_selectQuestionsCountByAccountId+'?childQuestionStatus='+this.questionsStatus).then((res)=>{
            if(res.data.code==1){
                this.data=res.data.data;

            }
            else {
              alert(res.data.msg)
            }
      })
    },
    initData(){
      this.getData();
      this.getDatas();
    }
  },
  created () {
    this.getData();
    this.getDatas();
    console.log(this.isbuy)
  },
  mounted() {
    bus.$on('bugTag',(res)=>{
        this.isbuy=res;
    })
  }
}
</script>

<style scoped>
.buy {
  color: #fff;
  background-color: #4fa7ff;
  height: 44px;
  width: 80px;
  text-align: center;
  line-height: 44px;
  margin-right: 15px;
}

.live .lists {
  padding: 0 15px;
  text-indent: 0;
  border-bottom: 1px solid #ccc;
}

/* .live .lists .view {
  	color: #fff;
  	background-color: #4fa7ff;
  	height: 44px;
  	width: 80px;
  	text-align: center;
  	line-height: 44px;
  } */
.live .lists .list:last-child,
.live .lists .listtile {
  border-bottom: none !important;
  text-indent: 25px;
}

.line {
  height: 1px;
  background-color: silver;
  margin: 0 -15px;
}

.childName {
  text-indent: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/training.vue